import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NotFoundProps {
  title?: string;
  subtitle?: string;
}

export const NotFound: React.FC<NotFoundProps> = ({ title, subtitle }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen bg-primary-inverse flex flex-col items-center justify-center px-4">
      <div className="text-center space-y-8 max-w-2xl">
        {/* Flying Pigeon Animation */}
        <div className="relative h-32">
          <div className="absolute left-0 animate-fly-across">🐦</div>
          <div className="absolute left-1/4 animate-fly-across-delay-1">🐦</div>
          <div className="absolute left-1/2 animate-fly-across-delay-2">🐦</div>
        </div>

        {/* 404 Text */}
        <h1 className="text-9xl font-bold text-secondary animate-bounce">404</h1>

        {/* Message */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-secondary">
            {title ?? t('notFound.title') + ' 🕊️'}
          </h2>
          <p className="text-xl text-[#3B5266]">{subtitle ?? t('notFound.subtitle') + ' ☕'}</p>
        </div>

        {/* Bread Crumbs Trail */}
        <div className="flex justify-center space-x-2 text-2xl">🍞 🍞 🍞</div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 bg-primary text-white rounded-full font-bold hover:bg-[#3B5266] transition-colors"
          >
            {t('notFound.backButton')}
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-primary text-white rounded-full font-bold hover:bg-[#3B5266] transition-colors"
          >
            {t('notFound.homeButton')}
          </button>
        </div>

        {/* Fun Footer */}
        <div className="mt-12 text-[#3B5266] text-sm">
          <p>💭 {t('notFound.footer1')}</p>
          <p className="mt-2">🕊️ {t('notFound.footer2')}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
